<!--
 * @Author: awu
 * @Date: 2020-11-15 11:39:41
 * @LastEditors: awu
 * @LastEditTime: 2020-12-09 23:03:52
 * @Description: 会议厅首页
-->
<template>
    <div class="conference">
        <!-- <div class="play" @click="playVideo">
            <img src="../../assets/conference/play.png" alt="" />
        </div> -->
        <!-- <div class="box box1" @click="toPage(1)" style="margin-right:220px">
            <p>{{ conference.bigconference }}</p>
        </div>
        <div class="box box2" @click="toPage(2)">
            <p>{{ conference.smallconference }}</p>
        </div> -->
        <!-- <Video style="zIndex:2" v-if="videoFlag" :src="videoSrc" @close="close" /> -->
        <iframe :src="iframesrc"  style="width:100%;height:100%;border:0;" ></iframe>
        <!-- <template v-if="$route.path === '/area/conference'">
            <div class="hotarea hotarea-box1" @click="toPage(1)"></div>
            <div class="hotarea hotarea-box2" @click="toPage(2)"></div>
        </template> -->
    </div>
</template>

<script>
import Video from "../../components/video";
export default {
    components: {
        Video
    },
    data() {
        return {
            iframesrc: '',
            videoFlag: false,
            exhibition_id: '',
        };
    },
    mounted() {
        this.exhibition_id = this.$route.query.exhibition_id
    },
    watch: {
        $route: {
            handler(route) {
                let route_exhibition_id = route.query.exhibition_id
                if(route_exhibition_id){
                    switch (route.query.exhibition_id) {
                        case '21':
                            this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=634b5df6c0660e8b";
                            break;
                        case '25':
                            this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=6a4b23a8c77676ba";
                            break;
                        case '31':
                            this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=0bbefa78635cdd3d";
                            break;
                        case '50':
                            this.iframesrc = "https://veh.cloudvhall.com/#/preview/SFZWc2ZVK25ES211MVM2dm83WExpQT09";
                            break;
                        case '60':
                            this.iframesrc = "https://veh.cloudvhall.com/#/preview/SytuR2hocFYwTkxhbGJQOFFuTUhyZz09";
                            break;
                        case '82':
                            this.iframesrc = "https://veh.cloudvhall.com/#/preview/ZzRIOS8rMVZNMGFSRXF5Qzg3Q0padz09";
                            break;
                        default:
                            break;
                    }
                }
            },
		    immediate: true,
        },
    },
    methods: {
        toPage(num) {
            if (num == 1) {
                this.$router.push("bigconference?exhibition_id="+this.exhibition_id);
            } else {
                this.$router.push("smallconference?exhibition_id="+this.exhibition_id);
            }
        },
        playVideo() {
            this.videoFlag = true;
            this.btnShowFlag = false;
        },
        close() {
            this.videoFlag = false;
            this.btnShowFlag = true;
        }
    },
    computed: {
        conference() {
            return this.$t("conference");
        }
    }
};
</script>

<style lang="scss" scoped>
.conference {
    width: 100%;
    height: 100vh;
    //background: url("../../assets/conference/hytBc.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .play {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #595b5f;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 30%;
        left: 50%;
        transform: translateX(-50%);
    }
    .box1 {
        cursor: pointer;
        left: 26%;
    }
    .box2 {
        cursor: pointer;
        right: 27.5%;
    }
    .box {
        width: 150px;
        height: 90px;
        background: #09468c;
        box-shadow: 1px 3px 4px 0px rgba(0, 0, 0, 0.2), -1px -3px 4px 0px rgba(255, 255, 255, 0.4);
        border-radius: 13px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #dfe8f9;

        text-align: center;
        position: absolute;
        top: 51%;
        p {
            width: 120px;
            height: 100%;
            background: url("../../assets/ren.png") no-repeat;
            background-size: 100% 100%;
            margin: 0 auto;
            word-wrap: break-word;
            line-height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    .hotarea {
        width: 80px;
        height: 80px;
        position: fixed;
        background: url("~@/assets/hot.gif") no-repeat center;
        background-size: 100% 100%;
        cursor: pointer;
        &-box1 {
            top: 42.78%;
            left: 40.5%;
        }
        &-box2 {
            top: 42.78%;
            right: 38.4%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/conference/index.vue